import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import DoDisturbOnRoundedIcon from '@mui/icons-material/DoDisturbOnRounded';
import { useCallback } from 'react';
import { createShowBlockedPlayersOutbound } from '../../../api/outbound/commonOutbounds';
import { MenuItemContainer } from '../../../components/menuItemContainer';
import { useSocketSend } from '../../../context/webSocket/webSocketContext';
import { useAppSelector } from '../../../redux/store';
export const BlockedPlayersAdminActionsMenuItem = ({ playerIdName, closeMenu }) => {
    const socketSend = useSocketSend();
    const isSelfAdmin = useAppSelector((state) => state.selfData.isAdmin);
    const onClick = useCallback(() => {
        socketSend(createShowBlockedPlayersOutbound(playerIdName.id));
    }, [playerIdName.id, socketSend]);
    if (!isSelfAdmin) {
        return null;
    }
    return (_jsx(MenuItemContainer, { label: 'Blocked Players', svgIconComponent: DoDisturbOnRoundedIcon, onClick: onClick, closeMenu: closeMenu }));
};
